"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConsoleWriter = /** @class */ (function () {
    function ConsoleWriter() {
    }
    ConsoleWriter.prototype.write = function (message) {
        // eslint-disable-next-line no-console
        console.log(message);
    };
    return ConsoleWriter;
}());
exports.ConsoleWriter = ConsoleWriter;
//# sourceMappingURL=consoleWriter.js.map